module.exports = __webpack_public_path__ + "static/media/card-worker.7e590a8b.svg";